import { BACKEND_URL } from "../url/Url";

const PERSONNEL_BASE = `${BACKEND_URL}`;

const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

const PersonnelService = {
  all: async () => {
    try {
      const response = await fetch(`${PERSONNEL_BASE}/users/`, {
        headers: getHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du personnel:', error);
      return { success: false, error: error.message };
    }
  },
  pass: async () => {
    try {
      const response = await fetch(`${PERSONNEL_BASE}/users/`, {
        headers: getHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du personnel:', error);
      return { success: false, error: error.message };
    }
  }
};
export default PersonnelService;

